export enum RoleEnum {
  CLIENT = 'CLIENT', // Regular user
  ASSOCIATE = 'ASSOCIATE', // A user with access to some Admin panel functionality
  ADMIN = 'ADMIN', // Regular Admin with full access to the Admin panel functionality
  SUPER_ADMIN = 'SUPER_ADMIN', // Super admin with full access for admins creating
}
